// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4859":"989c5884","8915":"e80da2aa","9998":"f5bd885c"}[chunkId] + ".chunk.css";
};